import { useEffect, useState, type FormEvent } from "react";

import { apiClient, type AuditEvent } from "../../api/client";
import { errorMessage } from "./errors";

export function AuditSearch() {
  const [events, setEvents] = useState<AuditEvent[]>([]);
  const [action, setAction] = useState("");
  const [outcome, setOutcome] = useState<AuditEvent["outcome"] | "">("");
  const [actorId, setActorId] = useState("");
  const [message, setMessage] = useState("");

  async function search(event?: FormEvent) {
    event?.preventDefault();
    try {
      setEvents(
        await apiClient.searchAuditEvents({
          action: action.trim() || undefined,
          outcome,
          actor_user_id: actorId.trim() || undefined,
          limit: 100,
        }),
      );
      setMessage("");
    } catch (error) {
      setMessage(errorMessage(error));
    }
  }

  useEffect(() => {
    void search();
  }, []);

  return (
    <section className="flow-panel" id="audit">
      <div className="panel-heading">
        <div>
          <span className="eyebrow">owner · 只追加摘要链</span>
          <h2>审计检索</h2>
        </div>
        <span className="phase-badge">{events.length} 条</span>
      </div>
      <form className="audit-filter" onSubmit={(event) => void search(event)}>
        <label>
          动作包含
          <input onChange={(event) => setAction(event.target.value)} value={action} />
        </label>
        <label>
          结果
          <select
            onChange={(event) => setOutcome(event.target.value as AuditEvent["outcome"] | "")}
            value={outcome}
          >
            <option value="">全部</option>
            <option value="success">success</option>
            <option value="failure">failure</option>
            <option value="denied">denied</option>
          </select>
        </label>
        <label>
          操作者 ID
          <input onChange={(event) => setActorId(event.target.value)} value={actorId} />
        </label>
        <button type="submit">检索</button>
      </form>
      {message && (
        <p className="alert error" role="alert">
          {message}
        </p>
      )}
      <div className="audit-list">
        {events.map((item) => (
          <article key={item.event_id}>
            <span>#{item.chain_sequence}</span>
            <div>
              <strong>{item.action}</strong>
              <small>
                {item.outcome} · {item.target_type} · {item.target_id ?? "—"}
              </small>
              <small>
                {new Date(item.occurred_at).toLocaleString()} · 请求 {item.correlation_id}
              </small>
            </div>
          </article>
        ))}
        {!events.length && <p className="panel-copy">当前筛选条件下没有审计事件。</p>}
      </div>
    </section>
  );
}
